module.exports = __webpack_public_path__ + "static/media/noun_Playing Cards_2371329.610a4ccb.svg";